/* ==============================================================
 * BKST v27 (22/10/2026): página do produto e cards.
 * - preço dentro do botão "Adicionar ao carrinho" (preço x quantidade)
 * - selo "Em estoque · postado em até 1 dia útil" abaixo do preço
 * - "Modelo veste" abaixo dos tamanhos (campo custom.modelo_veste)
 * - dúvidas frequentes no fim da coluna de compra
 * - torra e notas de sabor nos cards de café (campos custom.torra / custom.notas)
 * Dados vêm do snippet bkst-pdp-data (JSON #bkst-pdp-data).
 * ============================================================== */
(function () {
  var D = {};
  try { D = JSON.parse(document.getElementById('bkst-pdp-data').textContent) || {}; } catch (e) { D = {}; }
  var Y = '#f0ba38';

  function brl(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function css() {
    if (document.getElementById('bkst-pdp-style')) return;
    var s = document.createElement('style'); s.id = 'bkst-pdp-style';
    s.textContent = [
      '.bkst-ship{display:flex;align-items:center;gap:8px;margin:8px 0 0;font-size:13px;font-weight:600;}',
      '.bkst-ship__dot{width:8px;height:8px;border-radius:50%;background:#2ea05a;box-shadow:0 0 0 3px rgba(46,160,90,.18);flex-shrink:0;}',
      '.bkst-ship[hidden]{display:none;}',
      '.bkst-btn-price{margin-left:.45em;white-space:nowrap;}',
      '.bkst-modelo{margin:6px 0 0;font-size:12.5px;opacity:.8;}',
      '.bkst-faq{width:100%;margin:22px 0 0;border-top:1px solid rgba(128,128,128,.28);}',
      '.bkst-faq__t{margin:18px 0 6px;font-size:13px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:' + Y + ';}',
      '.bkst-faq details{border-bottom:1px solid rgba(128,128,128,.22);}',
      '.bkst-faq summary{list-style:none;cursor:pointer;display:flex;justify-content:space-between;align-items:center;gap:12px;padding:13px 0;font-size:14px;font-weight:700;}',
      '.bkst-faq summary::-webkit-details-marker{display:none;}',
      '.bkst-faq summary::after{content:"+";font-size:20px;font-weight:400;line-height:1;color:' + Y + ';transition:transform .2s;}',
      '.bkst-faq details[open] summary::after{transform:rotate(45deg);}',
      '.bkst-faq__a{padding:0 0 14px;font-size:13.5px;line-height:1.55;opacity:.88;}',
      '.bkst-faq__a a{color:' + Y + ';text-decoration:underline;text-underline-offset:3px;}',
      '.bkst-cafe-meta{margin:4px 0 0;font-size:12px;line-height:1.4;}',
      '.bkst-cafe-meta__t{display:inline-block;margin:0 6px 3px 0;padding:2px 7px;border:1px solid rgba(240,186,56,.55);border-radius:4px;color:' + Y + ';font-size:10.5px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;}',
      '.bkst-cafe-meta__n{opacity:.8;}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- cards de café ---------- */
  function cafeCards() {
    var map = D.cafes || {};
    Object.keys(map).forEach(function (h) {
      var info = map[h]; if (!info || (!info.t && !info.n)) return;
      document.querySelectorAll('.product-item a[href*="/products/' + h + '"]').forEach(function (a) {
        var card = a.closest('.product-item'); if (!card || card.querySelector('.bkst-cafe-meta')) return;
        var title = card.querySelector('.product-item-meta__title') || card.querySelector('.product-item-meta');
        if (!title) return;
        var m = document.createElement('div'); m.className = 'bkst-cafe-meta';
        if (info.t) { var t = document.createElement('span'); t.className = 'bkst-cafe-meta__t'; t.textContent = info.t; m.appendChild(t); }
        if (info.n) { var n = document.createElement('span'); n.className = 'bkst-cafe-meta__n'; n.textContent = info.n; m.appendChild(n); }
        title.insertAdjacentElement('afterend', m);
      });
    });
  }

  /* ---------- página do produto ---------- */
  var P = D.product, price = P ? P.price : 0, avail = P ? P.available : false;

  function qty() {
    var i = document.querySelector('.product__info .quantity-selector__input') || document.querySelector('.product__info input[name="quantity"]');
    var q = i ? parseInt(i.value, 10) : 1; return isNaN(q) || q < 1 ? 1 : q;
  }
  function addBtn() { return document.querySelector('.product__info .product-form__add-button') || document.querySelector('.product-form__add-button'); }
  function paintButton() {
    var b = addBtn(); if (!b || !P) return;
    if (b.disabled || !avail || !price) { var o = b.querySelector('.bkst-btn-price'); if (o) o.remove(); return; }
    var host = b.querySelector('.loader-button__text') || b;
    var sp = b.querySelector('.bkst-btn-price');
    if (sp && sp.parentNode !== host) { sp.remove(); sp = null; }
    if (!sp) { sp = document.createElement('span'); sp.className = 'bkst-btn-price'; host.appendChild(sp); }
    sp.textContent = '· ' + brl(price * qty());
  }
  function paintShip() {
    if (!P) return;
    var el = document.querySelector('.bkst-ship');
    if (!el) {
      var ref = document.querySelector('.product__info .bkst-parcelamento') || document.querySelector('.product__info .bkst-pix') || document.querySelector('.product__info .product-meta__price-list-container');
      if (!ref) return;
      el = document.createElement('div'); el.className = 'bkst-ship';
      el.innerHTML = '<span class="bkst-ship__dot" aria-hidden="true"></span><span>Em estoque · postado em até 1 dia útil</span>';
      ref.insertAdjacentElement('afterend', el);
    }
    el.hidden = !avail;
  }
  function paintModelo() {
    if (!P || !P.modelo || document.querySelector('.bkst-modelo')) return;
    var info = document.querySelector('.product__info .product-form__option-info');
    if (!info) return;
    var p = document.createElement('p'); p.className = 'bkst-modelo'; p.textContent = P.modelo;
    var sel = info.closest('.product-form__option-selector') || info;
    sel.insertAdjacentElement('beforeend', p);
  }

  function faqItems() {
    var t = (P.type || '').toLowerCase(), h = P.handle || '';
    var L = [];
    if (t.indexOf('camiseta') > -1) {
      L.push(['Qual tamanho escolher?', 'Modelagem reta e unissex. Compare uma camiseta que veste bem em você com a <a href="/pages/tabela-de-medidas">tabela de medidas</a>, ou use o "Descubra seu tamanho" acima. Na dúvida entre dois tamanhos, fique com o maior.']);
      L.push(['Qual o tecido? Encolhe?', 'Malha 100% algodão, fio 30.1 penteado, 170 g/m², pré-lavada: encolhe no máximo 2%. As peças Washed Series são estonadas, com malha de 160 g. Veja <a href="/pages/como-lavar">como lavar</a> para a estampa durar anos.']);
    }
    if (t.indexOf('caf') > -1 && h.indexOf('drip') === -1) {
      L.push(['Moído ou em grãos?', 'Os dois: escolha na hora da compra. Moído serve coador, prensa francesa e cafeteira italiana; em grãos é para quem mói na hora.']);
      L.push(['Tem desconto levando mais cafés?', 'Tem. 2 cafés de 250 g saem com 15% de desconto e 3 ou mais com 20%, misturando como quiser. O desconto entra sozinho no carrinho e não acumula com cupom.']);
    }
    if (t.indexOf('adesivo') > -1) {
      L.push(['Como aplicar o adesivo?', 'Em superfície lisa, limpa e seca. Limpe com álcool, posicione e aperte do centro para a borda para não fazer bolha. Espere 24 horas antes de molhar ou lavar.']);
      L.push(['Tem desconto levando mais?', 'Tem. 3 adesivos saem com 10% de desconto, 5 com 15% e 10 ou mais com 30%. O desconto entra sozinho no carrinho e não acumula com cupom.']);
    }
    L.push(['Quando meu pedido é enviado?', 'Postamos em até 1 dia útil depois da confirmação do pagamento (Pix e cartão confirmam na hora). O código de rastreio chega no seu e-mail. O prazo até a sua casa aparece em "Calcular frete e prazo", aqui em cima, com o seu CEP.']);
    L.push(['Quando o frete é grátis?', 'Em compras a partir de R$ 300 em produtos, para todo o Brasil, na opção de entrega mais econômica. As demais opções, como Sedex, são cobradas. Usar cupom de desconto não tira o frete grátis.']);
    L.push(['Quais as formas de pagamento?', 'Pix com 4% de desconto ou cartão de crédito em até 2x sem juros.']);
    L.push(['Como funciona a troca?', 'Não serviu: troca em até 7 dias depois de receber, com a peça sem uso e com etiqueta; você envia a peça e o reenvio da nova é por nossa conta. Desistiu: devolvemos o valor integral em até 7 dias. Veio com defeito: avise em até 90 dias, com fotos, e todo o frete é por nossa conta. Fale com a gente no WhatsApp <a href="https://wa.me/5521997844136" target="_blank" rel="noopener">(21) 99784-4136</a>. <a href="/pages/trocas-e-devolucoes">Política completa</a>.']);
    return L;
  }
  function paintFaq() {
    if (!P || document.querySelector('.bkst-faq')) return;
    var info = document.querySelector('.product__info'); if (!info) return;
    var w = document.createElement('div'); w.className = 'bkst-faq';
    var html = '<p class="bkst-faq__t">Dúvidas frequentes</p>';
    faqItems().forEach(function (it) { html += '<details><summary>' + it[0] + '</summary><div class="bkst-faq__a">' + it[1] + '</div></details>'; });
    w.innerHTML = html;
    info.appendChild(w);
  }
  // O kit do operador se move para o fim da coluna depois de carregar; o FAQ fica sempre por último.
  function keepFaqLast() {
    var f = document.querySelector('.bkst-faq'); if (f && f.parentNode && f.parentNode.lastElementChild !== f) f.parentNode.appendChild(f);
  }

  function pdp() { if (!P) return; paintShip(); paintModelo(); paintButton(); paintFaq(); keepFaqLast(); }

  function run() { css(); cafeCards(); pdp(); }

  document.addEventListener('DOMContentLoaded', run);
  setTimeout(run, 600); setTimeout(run, 1500); setTimeout(keepFaqLast, 3000);

  if (P) {
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (v) { if (typeof v.price === 'number') price = v.price; avail = !!v.available; }
      setTimeout(function () { paintShip(); paintButton(); }, 80);
    });
    ['input', 'change'].forEach(function (ev) {
      document.addEventListener(ev, function (e) { if (e.target && e.target.name === 'quantity') paintButton(); }, true);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.quantity-selector__button')) { setTimeout(paintButton, 40); }
    }, true);
  }

  // Cards que chegam depois (filtros da coleção, recomendações).
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(cafeCards, 250); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
